import { RoleTypeStrategy } from '../strategies/user_mode_api_strategy';
export class APCommandUrlServant {
  constructor(private $state: ng.ui.IStateService) {}

  private API_PREFIX_LOOKUP = {
    academicPlan: {
      advisor: `/reg/advisorplan`,
      student: `/reg/academicplan`,
      default: `/reg/academicplan`
    },
    courseGroup: {
      advisor: `/academicplan/suggested_course_group`,
      student: `/academicplan/planned_course_group`,
      default: `/academicplan/planned_course_group`
    }
  };
  get(key: string) {
    const userType = RoleTypeStrategy.evaluate(this.$state);
    return this.API_PREFIX_LOOKUP[key][userType];
  }
}

angular.module('capability-ng-academic-planner').service('ngAPCommandUrlServant', APCommandUrlServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_command_url_servant.ts